import { useMemo } from "react";
import { Provider } from "react-redux";
import {
  createBrowserRouter,
  createRoutesFromElements,
  Navigate,
  Outlet,
  Route,
  RouterProvider,
} from "react-router-dom";
import InteractionTemplates from "./InteractionTemplates/InteractionTemplates";
import ListingAlertTemplates from "./ListingAlertTemplates/ListingAlertTemplates";
import TextTemplates from "./TextTemplates/TextTemplates";

const TemplatesLayout = () => (
  <div className="tw-flex tw-flex-col tw-gap-[16px] tw-px-[32px] tw-py-[24px] tw-h-full">
    <h1 className="tw-text-28px tw-text-gray-75 tw-font-normal tw-my-0">Templates</h1>
    <Outlet />
  </div>
);

const SettingsTemplatesApp = () => {
  const store = useMemo(() => ReactOnRails.getStore("layoutStore"), []);

  const router = useMemo(
    () =>
      createBrowserRouter(
        createRoutesFromElements(
          <Route path="/" element={<TemplatesLayout />}>
            <Route index element={<Navigate to="email" replace />} />
            <Route path="email" element={<InteractionTemplates />} />
            <Route path="text" element={<TextTemplates />} />
            <Route path="listing-alerts" element={<ListingAlertTemplates />} />
            <Route path="*" element={<Navigate to="email" replace />} />
          </Route>,
        ),
        { basename: "/settings/templates" },
      ),
    [],
  );

  return (
    <Provider store={store}>
      <RouterProvider router={router} />
    </Provider>
  );
};

export default SettingsTemplatesApp;
